import React from "react"
import { Button, Col, Row } from "react-bootstrap"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"

// Kairos
import CheckInput from "../../../../components/InputWrapper/CheckInput"

const MakeInvoicePrintModal: React.FC<
  TModalTypes & {
    合計表題切替: number
    set合計表題切替: (value: number) => unknown
    表題切替: number
    set表題切替: (value: number) => unknown
    備考要否: number
    set備考要否: (value: number) => unknown
    頁不要: number
    set頁不要: (value: number) => unknown
    isExecPrint: boolean
    setIsExecPrint: (value: boolean) => unknown
    /**
     * 請求書表紙編集ページであるかどうか
     */
    isHeaderPage?: boolean
  }
> = (props) => {
  //#region [method]
  //#endregion

  //#region [state]
  //#endregion

  // 合計表題切替のチェックが変更されたときのイベントハンドラ
  const handle合計表題切替Change = (value: number) => {
    props.set合計表題切替(value)

    // 合計表題切替がオンになったら、表題切替を自動的にオフにする
    if (value === 1) {
      props.set表題切替(0)
    }
  }

  // 表題切替のチェックが変更されたときのイベントハンドラ
  const handle表題切替Change = (value: number) => {
    props.set表題切替(value)

    // 表題切替がオンになったら、合計表題切替を自動的にオフにする
    if (value === 1) {
      props.set合計表題切替(0)
    }
  }

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title}
      setIsShow={props.setIsShow}
      size={props.size}>
      {props.isHeaderPage && (
        <div className="text-danger">現在の登録で更新し、印刷を行います。</div>
      )}
      <div style={{ marginBottom: "0.5rem" }}>以下の設定を選んでください。</div>
      <div>
        <span className={"align-middle"}>
          <CheckInput
            id="合計表題切替"
            type={"checkbox"}
            label={"合同請求書添付として印刷"}
            setValue={handle合計表題切替Change}
            value={props.合計表題切替}
          />
        </span>
      </div>
      <div style={{ marginLeft: "3.5rem", marginBottom: "0.5rem" }}>
        ※社印は捺印されません
      </div>
      <div>
        <span className={"align-middle"}>
          <CheckInput
            id="表題切替"
            type={"checkbox"}
            label={"表題を「請求別紙」とする"}
            setValue={handle表題切替Change}
            value={props.表題切替}
          />
        </span>
      </div>
      <div style={{ marginLeft: "3.5rem", marginBottom: "0.5rem" }}>
        ※社印は捺印されません
      </div>
      <div style={{ marginBottom: "1rem" }}>
        <span className={"align-middle"}>
          <CheckInput
            id="備考要否"
            type={"checkbox"}
            label={"備考欄を印字する"}
            setValue={(v) => props.set備考要否(v)}
            value={props.備考要否}
          />
        </span>
      </div>
      <div style={{ marginBottom: "1rem" }}>
        <span className={"align-middle"}>
          <CheckInput
            id="頁不要"
            type={"checkbox"}
            label={"頁を印字しない"}
            setValue={(v) => props.set頁不要(v)}
            value={props.頁不要}
          />
        </span>
      </div>
      <div style={{ marginLeft: "3.5rem", marginBottom: "0.5rem" }}>
        請求書印刷区分が [1： 表紙・明細別印刷] の場合に有効です。
      </div>
      <Row className="search-button">
        <Col className="text-center">
          <Button
            className="w-9rem"
            variant="waiting"
            type="submit"
            onClick={() => {
              // TODO:登録,Validation,
              //beforeSubmit(props)
              props.setIsShow(false)
              props.setIsExecPrint(true)
            }}>
            印刷
          </Button>
        </Col>
      </Row>
    </ModalOuter>
  )
}

export default MakeInvoicePrintModal
